(function () {
  var TABLET_MIN = 750;
  var DESKTOP_MIN = 1025;
  var lastTrigger = null;

  function sidebar() {
    return document.querySelector('.m-header-sidebar');
  }

  function content() {
    return document.querySelector('.js-sidebar-content');
  }

  function bottom() {
    return document.querySelector('.m-header-sidebar__bottom');
  }

  function isMobile() {
    return window.innerWidth < TABLET_MIN;
  }

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function isOpen() {
    var node = sidebar();
    return !!node && node.classList.contains('m-header-sidebar--visible');
  }

  function directPanel(item) {
    if (!item) return null;
    for (var i = 0; i < item.children.length; i += 1) {
      if (item.children[i].classList.contains('m-header-sidebar__panel')) {
        return item.children[i];
      }
    }
    return null;
  }

  function cleanPanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-visible', 'is-animating', 'is-hiding');
    var nested = panel.querySelectorAll('.m-header-sidebar__panel');
    for (var i = 0; i < nested.length; i += 1) {
      nested[i].classList.remove('is-visible', 'is-animating', 'is-hiding');
    }
  }

  function updateContentState() {
    var node = content();
    var root = sidebar();
    if (!node || !root) return;

    var visiblePanels = root.querySelectorAll('.m-header-sidebar__panel.is-visible');
    var hasLevel2 = false;
    for (var i = 0; i < visiblePanels.length; i += 1) {
      if (visiblePanels[i].dataset.panel === '2') {
        hasLevel2 = true;
        break;
      }
    }

    node.classList.toggle('m-header-sidebar__content--has-panel', visiblePanels.length > 0);
    node.classList.toggle('m-header-sidebar__content--has-level-2', hasLevel2);
    root.setAttribute('aria-hidden', isOpen() ? 'false' : 'true');
  }

  function scheduleFocusSidebar() {
    var root = sidebar();
    if (root) root.setAttribute('aria-hidden', 'false');
    setTimeout(focusSidebar, 100);
    setTimeout(focusSidebar, 350);
    setTimeout(focusSidebar, 700);
  }

  function showDesktopPanel(trigger) {
    var item = trigger.parentElement;
    var panel = directPanel(item);
    if (!panel) return;

    var siblings = item.parentElement ? item.parentElement.children : [];
    for (var i = 0; i < siblings.length; i += 1) {
      if (siblings[i] !== item) {
        cleanPanel(directPanel(siblings[i]));
      }
    }

    panel.classList.add('is-visible');
    panel.classList.remove('is-hidden', 'is-animating', 'is-hiding');
    updateContentState();
  }

  function showSlidePanel(trigger) {
    var item = trigger.parentElement;
    var panel = directPanel(item);
    if (!panel) return;

    var siblings = item.parentElement.children;
    for (var i = 0; i < siblings.length; i += 1) {
      var sib = siblings[i];
      if (sib.classList.contains('m-header-sidebar__back')) {
        sib.classList.add('is-hidden');
      } else if (sib.firstElementChild) {
        sib.firstElementChild.classList.add('is-hidden');
      }
    }

    var foot = bottom();
    var node = content();
    if (foot) foot.classList.add('is-hiding');
    if (node) node.classList.add('is-animating');
    panel.classList.add('is-animating');

    setTimeout(function () {
      if (foot) {
        foot.classList.add('is-hidden');
        foot.classList.remove('is-hiding');
      }
      panel.classList.add('is-visible');
      panel.classList.remove('is-animating');
      if (node) node.classList.remove('is-animating');
      updateContentState();
    }, 500);
  }

  function backDesktopPanel(button) {
    var panel = button.closest('.m-header-sidebar__panel');
    if (!panel) return;
    cleanPanel(panel);
    updateContentState();
  }

  function backSlidePanel(button) {
    var panel = button.closest('.m-header-sidebar__panel');
    if (!panel) return;

    var level = panel.dataset.panel;
    var item = panel.parentElement;
    var container = item.parentElement;
    var siblings = container.children;
    var node = content();

    for (var i = 0; i < siblings.length; i += 1) {
      var sib = siblings[i];
      if (sib.classList.contains('m-header-sidebar__back')) {
        sib.classList.remove('is-hidden');
        sib.classList.add('is-animating');
      } else if (sib.firstElementChild) {
        sib.firstElementChild.classList.remove('is-hidden');
        sib.firstElementChild.classList.add('is-animating');
      }
    }

    if (node) node.classList.add('is-animating');
    if (level === '1' && bottom()) {
      bottom().classList.remove('is-hidden');
      bottom().classList.add('is-animating');
    }
    panel.classList.add('is-hiding');

    setTimeout(function () {
      for (var i = 0; i < siblings.length; i += 1) {
        var sib = siblings[i];
        if (sib.classList.contains('m-header-sidebar__back')) {
          sib.classList.remove('is-animating');
        } else if (sib.firstElementChild) {
          sib.firstElementChild.classList.remove('is-animating');
        }
      }
      panel.classList.remove('is-visible', 'is-hiding');
      if (node) node.classList.remove('is-animating');
      if (level === '1' && bottom()) bottom().classList.remove('is-animating');
      updateContentState();
    }, 500);
  }

  function visibleFocusable() {
    var node = content();
    if (!node) return [];
    var selector = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(node.querySelectorAll(selector), function (el) {
      if (el.closest('.m-header-sidebar__panel:not(.is-visible)')) return false;
      if (el.closest('.is-hidden')) return false;
      if (!el.getClientRects().length) return false;
      var style = window.getComputedStyle(el);
      return style.visibility !== 'hidden' && style.display !== 'none';
    });
  }

  function focusSidebar() {
    if (!isOpen()) return;
    updateContentState();
    var close = document.querySelector('.js-sidebar-close');
    var targets = visibleFocusable();
    (close || targets[0] || content()).focus({ preventScroll: true });
  }

  function restoreFocusIfClosed() {
    if (!isOpen()) {
      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus({ preventScroll: true });
      }
      updateContentState();
    }
  }

  function requestClose() {
    var close = document.querySelector('.js-sidebar-close');
    if (close) {
      close.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(restoreFocusIfClosed, 650);
    }
  }

  document.addEventListener('click', function (event) {
    if (isMobile()) return;

    var root = sidebar();
    if (!root || !root.contains(event.target)) return;

    var showButton = event.target.closest('.js-show-panel');
    if (showButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isDesktop()) {
        showDesktopPanel(showButton);
      } else {
        showSlidePanel(showButton);
      }
      return;
    }

    var backButton = event.target.closest('.js-back-to-prev-panel');
    if (backButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isDesktop()) {
        backDesktopPanel(backButton);
      } else {
        backSlidePanel(backButton);
      }
    }
  }, true);

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('.js-hamburger');
    if (opener) {
      lastTrigger = opener;
      scheduleFocusSidebar();
      return;
    }

    if (event.target.closest('.js-sidebar-close') || event.target.closest('.js-sidebar-underlay')) {
      setTimeout(restoreFocusIfClosed, 650);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      requestClose();
      return;
    }

    if (event.key !== 'Tab') return;
    var targets = visibleFocusable();
    if (!targets.length) {
      event.preventDefault();
      if (content()) content().focus({ preventScroll: true });
      return;
    }

    var first = targets[0];
    var last = targets[targets.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  });

  window.addEventListener('resize', updateContentState);
  var initialSidebar = sidebar();
  if (initialSidebar) {
    new MutationObserver(function () {
      if (isOpen()) {
        scheduleFocusSidebar();
      } else {
        restoreFocusIfClosed();
      }
    }).observe(initialSidebar, { attributes: true, attributeFilter: ['class'] });
  }
  updateContentState();
})();
